<!--
Public: Banner alerting members and guests we use cookies.

Example:
  <cookie-banner user-id          = "<%= current_user.id %>"
                 accepted-cookies = "<%= current_user.accepted_cookies %>">
  </cookie-banner>
-->
<template>
  <div v-if="!hasAcceptedCookies" class="position-fixed bottom-0 w-100 py-4 background-color-lightest-gray border border-color-dark-grey ui-z-index-top">
    <div class="container text-center color-nav-blue fs-6">
      This website uses cookies for analysis, personalized content and advertising. By using this website you agree to this use.

      <div class="d-flex mt-2 mt-xl-0 d-xl-inline-flex justify-content-center align-items-center">
        <a href="/privacy" target="_blank">Further information</a>
        <button @click="accept" class="btn background-color-nav-blue text-white ms-2">I Agree</button>
      </div><!-- .d-flex -->
    </div><!-- .container -->
  </div><!-- .position-fixed -->
</template>

<script>
  import { put }       from '../lib/async'
  import { toBoolean } from '../lib/utils'

  export default {
    props: {
      // Whether the current user has accepted cookies.
      acceptedCookies: { default: false },
      // The user's ID.
      userId:          { default: null }
    },

    data() {
      return {
        // Public: Whether to render the banner.
        viewedBanner: window.localStorage.getItem('viewedGdprBanner')
      }
    },

    computed: {
      // Internal: Whether the 'accept cookies' banner should be rendered.
      hasAcceptedCookies() {
        return toBoolean(this.acceptedCookies) || toBoolean(this.viewedBanner)
      }
    },

    methods: {
      // Public: Accept cookies and hide the banner.
      accept() {
        this.viewedBanner = true

        if (this.userId == null) {
          window.localStorage.setItem('viewedGdprBanner', true)
        } else {
          put('/api/members/accept_cookies', { id: this.userId })
        }
      }
    }
  }
</script>
